<template>
  <div class="comment-page">
    <el-tabs v-model="activeTab" @tab-click="loadData">
      <el-tab-pane :label="$t('message.home.pendingComment')" name="pending" />
      <el-tab-pane :label="$t('message.home.commented')" name="done" />
    </el-tabs>
    <div v-loading="loading">
      <div v-for="item in list" :key="item.id" class="comment-item">
        <img :src="item.goodsThumbnail || item.thumbnail" class="goods-img" />
        <div class="goods-info">
          <div class="goods-name">{{ item.goodsName || item.name }}</div>
          <div class="goods-spec" v-if="item.specs">{{ item.specs }}</div>
        </div>
        <div class="comment-content" v-if="item.content">
          <div class="stars">
            <el-rate :value="item.score || item.star" disabled />
          </div>
          <div class="content-text">{{ item.content }}</div>
        </div>
        <div class="comment-action" v-if="activeTab === 'pending'">
          <el-button type="primary" size="small" @click="goEvaluate(item)">
            {{ $t('message.home.evaluate') }}
          </el-button>
        </div>
      </div>
      <el-empty v-if="!list.length && !loading" :description="$t('message.home.noData')" />
    </div>
    <el-pagination v-if="total > 0" background layout="prev, pager, next"
      :total="total" :page-size="queryParams.pageSize"
      @current-change="(p) => { queryParams.pageNumber = p; loadData() }"
      style="margin-top:20px;text-align:center" />
  </div>
</template>

<script>
import { member_review_list } from '@/api/goods/review'

export default {
  name: 'MyComment',
  data() {
    return {
      loading: false, activeTab: 'pending', list: [], total: 0,
      queryParams: { pageNumber: 1, pageSize: 10 }
    }
  },
  created() { this.loadData() },
  methods: {
    loadData() {
      this.loading = true
      const params = { ...this.queryParams, isReview: this.activeTab === 'done' ? 1 : 0 }
      member_review_list(params).then(r => {
        const data = r.data?.data || r.data || {}
        this.list = data.content || data.list || []
        this.total = data.total || 0
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    goEvaluate(item) {
      this.$router.push({ path: '/userInfo/order-evaluation', query: { orderId: item.orderId } })
    }
  }
}
</script>

<style lang="scss" scoped>
.comment-item { display: flex; align-items: flex-start; gap: 16px; padding: 16px 0; border-bottom: 1px solid #f0f0f0; }
.goods-img { width: 72px; height: 72px; object-fit: cover; border-radius: 4px; flex-shrink: 0; }
.goods-info { flex: 1; }
.goods-name { font-size: 14px; color: #303133; margin-bottom: 4px; }
.goods-spec { font-size: 12px; color: #909399; }
.comment-content { flex: 2; }
.content-text { font-size: 13px; color: #606266; margin-top: 6px; }
.comment-action { flex-shrink: 0; }
</style>
